<template>
  <div class="card">
    <module-title :module-title="moduleTitle"/>
    <ul class="cardList double-between">
      <li
        v-for="(item,index) in list"
        :key="index"
        class="card-item"
        @click="byCard(item)">
        <img
          :src="item.img"
          class="imgs">
      </li>
    </ul>
  </div>
</template>

<script>
import ModuleTitle from '@/components/title/ModuleTitle'

export default {
  name: 'SwipeActive',
  components: {ModuleTitle},
  props: {
    moduleTitle: {
      type: Object,
      default: function () {
        return {}
      }
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    byCard (item) {
      this.$utils.checkCanGoRouter(item.url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .card {
    background: #fff;
  }
  .cardList {
    background: #fff;
    padding: $padding;
    margin-top: -$padding;
    .card-item {
      width: 48%;
      .imgs {
        width: 100%;
        height: 106px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/swiper/SwipeActive.vue